import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.applicatorConfig',
    modules: [
        R,
    ],
})
@Service('ApplicatorConfigStore')
export default class Store extends BaseStore {

    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('applicators-config');
    }

}



// WEBPACK FOOTER //
// ./src/app/stores/applicator.config.js